import { httpClient } from "../http/httpClient";

export type UpdateLinkRequest = {
  label?: string;
  tables?: string[];
};

export type UpdateLinkResponse = {
  _id: string;
  name: string;
  label: string;
  seller: string;
  tables: string[];
};

export const updateLink = async (id: string, params: UpdateLinkRequest) => {
  const { data } = await httpClient
    .put<UpdateLinkResponse>(`/self-hire/${id}`, params)
    .catch((error) => {
      throw error?.response?.data || error;
    });

  return data;
};
